import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

/* Layout */
import Layout from '../views/layout/Layout';

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true,
  },
  { path: '/404', component: () => import('@/views/404'), hidden: true },
  {
    path: '/',
    component: Layout,
    hidden: true,
  },
  {
    path: '/403',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '',
        name: 'forbidden',
        component: () => import('@/views/403'),
        meta: { title: '暂无访问权限' },
      },
    ],
  },
];

export const asyncRouterMap = [
  {
    path: '/supplier', component: Layout, redirect: '/supplier/dashboard', name: 'supplier', meta: { title: '供应商中心', icon: 'shopping' },
    children: [
      { path: 'dashboard', name: 'supplierDashboard', component: () => import('@/views/supplier/dashboard'), meta: { title: '供应商工作台', icon: 'dashboard' } },
      { path: 'products', name: 'supplierProducts', component: () => import('@/views/supplier/products'), meta: { title: '关联商品', icon: 'product-list' } },
      { path: 'products/:id', name: 'supplierProductDetail', component: () => import('@/views/supplier/productDetail'), hidden: true, meta: { title: '商品详情', activeMenu: '/supplier/products', permissionMenu: 'supplierProducts' } },
      { path: 'orders', name: 'supplierOrders', component: () => import('@/views/supplier/orders'), meta: { title: '订单履约', icon: 'order' } },
      { path: 'orders/batch-ship', name: 'supplierBatchShip', component: () => import('@/views/supplier/batchShip'), hidden: true, meta: { title: '批量发货', activeMenu: '/supplier/orders', permissionMenu: 'supplierOrders' } },
      { path: 'orders/:id', name: 'supplierOrderDetail', component: () => import('@/views/supplier/orderDetail'), hidden: true, meta: { title: '订单详情', activeMenu: '/supplier/orders', permissionMenu: 'supplierOrders' } },
      { path: 'reports', name: 'supplierReports', component: () => import('@/views/supplier/reports'), meta: { title: '销量报表', icon: 'total-week' } },
      { path: 'accounts', name: 'supplierAccounts', component: () => import('@/views/supplier/accounts'), meta: { title: '账号管理', icon: 'ums-admin' } },
      { path: 'sms', name: 'supplierSmsSettings', component: () => import('@/views/supplier/smsSettings'), meta: { title: '短信提醒', icon: 'sms' } },
      {
        path: 'land',
        name: 'supplierLand',
        component: { render: h => h('router-view') },
        redirect: '/supplier/land/orders',
        meta: { title: '土地履约', icon: 'marker' },
        children: [
          { path: 'orders', name: 'supplierLandOrders', component: () => import('@/views/supplier/landOrders'), meta: { title: '土地订单', icon: 'order' } },
          { path: 'orders/:id', name: 'supplierLandOrderDetail', component: () => import('@/views/supplier/landOrderDetail'), hidden: true, meta: { title: '土地订单详情', activeMenu: '/supplier/land/orders', permissionMenu: 'supplierLandOrders' } },
          { path: 'products', name: 'supplierLandProducts', component: () => import('@/views/supplier/landProducts'), meta: { title: '土地商品', icon: 'product-list' } },
          { path: 'products/:id', name: 'supplierLandProductDetail', component: () => import('@/views/supplier/landProductDetail'), hidden: true, meta: { title: '土地商品详情', activeMenu: '/supplier/land/products', permissionMenu: 'supplierLandProducts' } },
          { path: 'services', name: 'supplierLandServices', component: () => import('@/views/supplier/landServices'), meta: { title: '配套服务', icon: 'product-list' } },
        ],
      },
    ],
  },
  {
    path: '/partner', component: Layout, redirect: '/partner/list', name: 'partner', meta: { title: '合作方管理', icon: 'ums-role' },
    children: [
      { path: 'list', name: 'partnerList', component: () => import('@/views/partner/index'), meta: { title: '合作方列表', icon: 'ums-admin' } },
      {
        path: 'brands/manage',
        name: 'partnerBrandManage',
        component: () => import('@/views/pms/brand/index'),
        meta: { title: '品牌管理', icon: 'product-brand' },
      },
      {
        path: 'brands/manage/add',
        name: 'partnerBrandAdd',
        component: () => import('@/views/pms/brand/add'),
        hidden: true,
        meta: { title: '添加品牌', permissionMenu: 'partnerBrandManage' },
      },
      {
        path: 'brands/manage/update',
        name: 'partnerBrandUpdate',
        component: () => import('@/views/pms/brand/update'),
        hidden: true,
        meta: { title: '编辑品牌', permissionMenu: 'partnerBrandManage' },
      },
      { path: 'brands', name: 'partnerBrands', component: () => import('@/views/partner/brands'), meta: { title: '品牌关联', icon: 'product-brand' } },
      { path: 'logs', name: 'partnerLogs', component: () => import('@/views/partner/logs'), meta: { title: '操作日志', icon: 'order' } },
    ],
  },
  {
    path: '/operations',
    component: Layout,
    redirect: '/operations/news',
    name: 'operations',
    meta: { title: '运营', icon: 'sms' },
    children: [
      {
        path: 'notice',
        name: 'notice',
        component: () => import('@/views/operations/notice/index'),
        meta: { title: '站内通知', icon: 'sms-subject' },
      },
      {
        path: 'news',
        name: 'news',
        component: () => import('@/views/operations/news/index'),
        meta: { title: '资讯', icon: 'sms-subject' },
      },
      {
        path: 'appPolicy',
        name: 'appPolicy',
        component: () => import('@/views/operations/appPolicy/index'),
        meta: { title: 'APP运营', icon: 'sms-subject' },
      },
    ],
  },
  {
    path: '/home',
    component: Layout,
    redirect: '/home/dashboard',
    name: 'home',
    meta: { title: '首页', icon: 'home' },
    children: [
      {
        path: 'dashboard',
        name: 'dashboard',
        component: () => import('@/views/home/index'),
        meta: { title: '仪表盘', icon: 'dashboard' },
      },
    ],
  },
  {
    path: '/system',
    component: Layout,
    redirect: '/system/dataDictionary',
    name: 'system',
    meta: { title: '系统设置', icon: 'security' },
    children: [
      {
        path: 'scheduledJobs',
        name: 'scheduledJobs',
        component: () => import('@/views/system/scheduledJobs'),
        meta: { title: '定时任务', icon: 'order' },
      },
      {
        path: 'dataDictionary',
        name: 'dataDictionary',
        // 保留字典目录这一层，使子页面和面包屑使用相同的菜单层级。
        component: { render: h => h('router-view') },
        redirect: '/system/dataDictionary/landCategories',
        meta: { title: '数据字典', icon: 'tree' },
        children: [
          {
            path: 'traceScenes',
            name: 'traceScenes',
            component: () => import('@/views/system/traceScenes/index'),
            meta: { title: '溯源场景', icon: 'tree' },
          },
          {
            path: 'landCategories',
            name: 'landCategories',
            component: () => import('@/views/land/categories/index'),
            meta: { title: '一亩地分类', icon: 'product-cate' },
          },
        ],
      },
    ],
  },
  {
    path: '/pms',
    component: Layout,
    redirect: '/pms/product',
    name: 'pms',
    meta: { title: '商品', icon: 'product' },
    children: [
      {
        path: 'comment',
        name: 'productComment',
        component: () => import('@/views/pms/comment/index'),
        meta: { title: '商品评价', icon: 'product-list' },
      },
      {
        path: 'product',
        name: 'product',
        component: () => import('@/views/pms/product/index'),
        meta: { title: '商品列表', icon: 'product-list' },
      },
      {
        path: 'addProduct',
        name: 'addProduct',
        component: () => import('@/views/pms/product/add'),
        meta: { title: '添加商品', icon: 'product-add' },
      },
      {
        path: 'updateProduct',
        name: 'updateProduct',
        component: () => import('@/views/pms/product/update'),
        meta: { title: '修改商品', icon: 'product-add' },
        hidden: true,
      },
      {
        path: 'productCate',
        name: 'productCate',
        component: () => import('@/views/pms/productCate/index'),
        meta: { title: '商品分类', icon: 'product-cate' },
      },
      {
        path: 'addProductCate',
        name: 'addProductCate',
        component: () => import('@/views/pms/productCate/add'),
        meta: { title: '添加商品分类' },
        hidden: true,
      },
      {
        path: 'updateProductCate',
        name: 'updateProductCate',
        component: () => import('@/views/pms/productCate/update'),
        meta: { title: '修改商品分类' },
        hidden: true,
      },
      {
        path: 'productAttr',
        name: 'productAttr',
        component: () => import('@/views/pms/productAttr/index'),
        meta: { title: '商品类型', icon: 'product-attr' },
      },
      {
        path: 'productAttrList',
        name: 'productAttrList',
        component: () => import('@/views/pms/productAttr/productAttrList'),
        meta: { title: '商品属性列表' },
        hidden: true,
      },
      {
        path: 'addProductAttr',
        name: 'addProductAttr',
        component: () => import('@/views/pms/productAttr/addProductAttr'),
        meta: { title: '添加商品属性' },
        hidden: true,
      },
      {
        path: 'updateProductAttr',
        name: 'updateProductAttr',
        component: () => import('@/views/pms/productAttr/updateProductAttr'),
        meta: { title: '修改商品属性' },
        hidden: true,
      },
    ],
  },
  {
    path: '/oms',
    component: Layout,
    redirect: '/oms/order',
    name: 'oms',
    meta: { title: '订单', icon: 'order' },
    children: [
      {
        path: 'order',
        name: 'order',
        component: () => import('@/views/oms/order/index'),
        meta: { title: '订单列表', icon: 'product-list' },
      },
      {
        path: 'orderDetail',
        name: 'orderDetail',
        component: () => import('@/views/oms/order/orderDetail'),
        meta: { title: '订单详情' },
        hidden: true,
      },
      {
        path: 'deliverOrderList',
        name: 'deliverOrderList',
        component: () => import('@/views/oms/order/deliverOrderList'),
        meta: { title: '发货列表' },
        hidden: true,
      },
      {
        path: 'orderSetting',
        name: 'orderSetting',
        component: () => import('@/views/oms/order/setting'),
        meta: { title: '订单设置', icon: 'order-setting' },
      },
      {
        path: 'returnApply',
        name: 'returnApply',
        component: () => import('@/views/oms/apply/index'),
        meta: { title: '退货申请处理', icon: 'order-return' },
      },
      {
        path: 'returnReason',
        name: 'returnReason',
        component: () => import('@/views/oms/apply/reason'),
        meta: { title: '退货原因设置', icon: 'order-return-reason' },
      },
      {
        path: 'returnApplyDetail',
        name: 'returnApplyDetail',
        component: () => import('@/views/oms/apply/applyDetail'),
        meta: { title: '退货原因详情' },
        hidden: true,
      },
    ],
  },
  {
    path: '/sms',
    component: Layout,
    redirect: '/sms/coupon',
    name: 'sms',
    meta: { title: '营销', icon: 'sms' },
    children: [
      {
        path: 'flash',
        name: 'flash',
        component: () => import('@/views/sms/flash/index'),
        meta: { title: '秒杀活动列表', icon: 'sms-flash' },
      },
      {
        path: 'flashSession',
        name: 'flashSession',
        component: () => import('@/views/sms/flash/sessionList'),
        meta: { title: '秒杀时间段列表' },
        hidden: true,
      },
      {
        path: 'selectSession',
        name: 'selectSession',
        component: () => import('@/views/sms/flash/selectSessionList'),
        meta: { title: '秒杀时间段选择' },
        hidden: true,
      },
      {
        path: 'flashProductRelation',
        name: 'flashProductRelation',
        component: () => import('@/views/sms/flash/productRelationList'),
        meta: { title: '秒杀商品列表' },
        hidden: true,
      },
      {
        path: 'coupon',
        name: 'coupon',
        component: () => import('@/views/sms/coupon/index'),
        meta: { title: '优惠券列表', icon: 'sms-coupon' },
      },
      {
        path: 'addCoupon',
        name: 'addCoupon',
        component: () => import('@/views/sms/coupon/add'),
        meta: { title: '添加优惠券' },
        hidden: true,
      },
      {
        path: 'updateCoupon',
        name: 'updateCoupon',
        component: () => import('@/views/sms/coupon/update'),
        meta: { title: '修改优惠券' },
        hidden: true,
      },
      {
        path: 'couponHistory',
        name: 'couponHistory',
        component: () => import('@/views/sms/coupon/history'),
        meta: { title: '优惠券领取详情' },
        hidden: true,
      },
      {
        path: 'brand',
        name: 'homeBrand',
        component: () => import('@/views/sms/brand/index'),
        meta: { title: '品牌推荐', icon: 'product-brand' },
      },
      {
        path: 'new',
        name: 'homeNew',
        component: () => import('@/views/sms/new/index'),
        meta: { title: '新品推荐', icon: 'sms-new' },
      },
      {
        path: 'hot',
        name: 'homeHot',
        component: () => import('@/views/sms/hot/index'),
        meta: { title: '人气推荐', icon: 'sms-hot' },
      },
      {
        path: 'subject',
        name: 'homeSubject',
        component: () => import('@/views/sms/subject/index'),
        meta: { title: '专题推荐', icon: 'sms-subject' },
      },
      {
        path: 'advertise',
        name: 'homeAdvertise',
        component: () => import('@/views/sms/advertise/index'),
        meta: { title: '广告列表', icon: 'sms-ad' },
      },
      {
        path: 'addAdvertise',
        name: 'addHomeAdvertise',
        component: () => import('@/views/sms/advertise/add'),
        meta: { title: '添加广告' },
        hidden: true,
      },
      {
        path: 'updateAdvertise',
        name: 'updateHomeAdvertise',
        component: () => import('@/views/sms/advertise/update'),
        meta: { title: '编辑广告' },
        hidden: true,
      },
    ],
  },
  {
    path: '/ums',
    component: Layout,
    redirect: '/ums/admin',
    name: 'ums',
    meta: { title: '权限', icon: 'ums' },
    children: [
      {
        path: 'admin',
        name: 'admin',
        component: () => import('@/views/ums/admin/index'),
        meta: { title: '用户列表', icon: 'ums-admin' },
      },
      {
        path: 'role',
        name: 'role',
        component: () => import('@/views/ums/role/index'),
        meta: { title: '角色列表', icon: 'ums-role' },
      },
      {
        path: 'allocMenu',
        name: 'allocMenu',
        component: () => import('@/views/ums/role/allocMenu'),
        meta: { title: '分配菜单' },
        hidden: true,
      },
      {
        path: 'allocResource',
        name: 'allocResource',
        component: () => import('@/views/ums/role/allocResource'),
        meta: { title: '分配资源' },
        hidden: true,
      },
      {
        path: 'menu',
        name: 'menu',
        component: () => import('@/views/ums/menu/index'),
        meta: { title: '菜单列表', icon: 'ums-menu' },
      },
      {
        path: 'addMenu',
        name: 'addMenu',
        component: () => import('@/views/ums/menu/add'),
        meta: { title: '添加菜单' },
        hidden: true,
      },
      {
        path: 'updateMenu',
        name: 'updateMenu',
        component: () => import('@/views/ums/menu/update'),
        meta: { title: '修改菜单' },
        hidden: true,
      },
      {
        path: 'resource',
        name: 'resource',
        component: () => import('@/views/ums/resource/index'),
        meta: { title: '资源列表', icon: 'ums-resource' },
      },
      {
        path: 'resourceCategory',
        name: 'resourceCategory',
        component: () => import('@/views/ums/resource/categoryList'),
        meta: { title: '资源分类' },
        hidden: true,
      },
    ],
  },
  {
    path: '/land',
    component: Layout,
    redirect: '/land/records',
    name: 'land',
    meta: { title: '土地资源', icon: 'marker' },
    children: [
      {
        path: 'records',
        name: 'landRecord',
        component: () => import('@/views/land/records/index'),
        meta: { title: '一亩地资料', icon: 'table' },
      },
      {
        path: 'records/create',
        name: 'landRecordCreate',
        component: () => import('@/views/land/records/editor'),
        meta: { title: '新增一亩地资料', activeMenu: '/land/records', permissionMenu: 'landRecord' },
        hidden: true,
      },
      {
        path: 'records/:landNo/edit',
        name: 'landRecordEdit',
        component: () => import('@/views/land/records/editor'),
        meta: { title: '编辑一亩地资料', activeMenu: '/land/records', permissionMenu: 'landRecord' },
        hidden: true,
      },
      { path: 'products', name: 'landProducts', component: () => import('@/views/land/resources/index'), meta: { title: '土地商品', icon: 'product-list', resourceKind: 'product' } },
      { path: 'products/create', name: 'landProductsCreate', component: () => import('@/views/land/resources/editor'), hidden: true, meta: { title: '新增土地商品', activeMenu: '/land/products', permissionMenu: 'landProducts', resourceKind: 'product' } },
      { path: 'products/:id/edit', name: 'landProductsEdit', component: () => import('@/views/land/resources/editor'), hidden: true, meta: { title: '编辑土地商品', activeMenu: '/land/products', permissionMenu: 'landProducts', resourceKind: 'product' } },
      { path: 'services', name: 'landServices', component: () => import('@/views/land/resources/index'), meta: { title: '配套服务', icon: 'product-list', resourceKind: 'service' } },
      { path: 'services/create', name: 'landServicesCreate', component: () => import('@/views/land/resources/editor'), hidden: true, meta: { title: '新增配套服务', activeMenu: '/land/services', permissionMenu: 'landServices', resourceKind: 'service' } },
      { path: 'services/:id/edit', name: 'landServicesEdit', component: () => import('@/views/land/resources/editor'), hidden: true, meta: { title: '编辑配套服务', activeMenu: '/land/services', permissionMenu: 'landServices', resourceKind: 'service' } },
      {
        path: 'orders',
        name: 'landOrders',
        component: () => import('@/views/land/orders/index'),
        meta: { title: '一亩地订单', icon: 'order' },
      },
      {
        path: 'orders/:id',
        name: 'landOrderDetail',
        component: () => import('@/views/land/orders/detail'),
        hidden: true,
        meta: { title: '土地订单详情', activeMenu: '/land/orders', permissionMenu: 'landOrders' },
      },
      {
        path: 'transactions',
        name: 'landTransaction',
        component: () => import('@/views/land/transactions/index'),
        meta: { title: '一亩地交易', icon: 'order' },
      },
      {
        path: 'transactions/:id',
        name: 'landTransactionDetail',
        component: () => import('@/views/land/transactions/detail'),
        hidden: true,
        meta: { title: '土地交易详情', activeMenu: '/land/transactions', permissionMenu: 'landTransaction' },
      },
      {
        path: 'listings',
        name: 'landListing',
        component: () => import('@/views/land/listings/index'),
        meta: { title: '挂牌管理', icon: 'product-list' },
      },
    ],
  },
  {
    path: '/member',
    component: Layout,
    redirect: '/member/list',
    name: 'member',
    meta: { title: '会员', icon: 'ms-role' },
    children: [
      {
        path: 'list',
        name: 'list',
        component: () => import('@/views/member/list/index'),
        meta: { title: '会员列表', icon: 'product-list' },
      },
      {
        path: 'points',
        name: 'memberPoints',
        component: () => import('@/views/member/points/index'),
        meta: { title: '会员浙豆宝', icon: 'product-list' },
      },
      {
        path: 'growth',
        name: 'memberGrowth',
        component: () => import('@/views/member/growth'),
        meta: { title: '成长明细', icon: 'list' }
      },
      {
        path: 'level',
        name: 'memberLevel',
        component: () => import('@/views/member/level/index'),
        meta: { title: '会员等级', icon: 'product-list' },
      },
    ],
  },
  { path: '*', redirect: '/404', hidden: true },
];

const createRouter = () =>
  new Router({
    // mode: 'history', //后端支持可开
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRouterMap,
  });

const router = createRouter();

// 动态路由会留在 matcher 中，退出时必须替换它，避免下一位用户继承旧权限。
export function resetRouter() {
  router.matcher = createRouter().matcher;
}

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js